document.addEventListener("DOMContentLoaded", ()=> {
    (()=> {
        const d = new Date();
        let year = d.getFullYear();
        const signNode = document.getElementById("footer__copyright");
        signNode.innerHTML = `
        <span class="">
            ©${year}. Cada cosa en su lugar. Todos los derechos reservados. 
        </span>
        <span class="lobo" style="font-size: 10px;">
            <img src="https://cdn.shopify.com/s/files/1/0161/4289/3104/files/logo-lc.webp">
            E-commerce desarrollado por 
            <a href="https://lobocreaciones.com/" target="_blank" style="cursor: pointer; color: inherit; text-decoration: none;" >Lobo Creaciones.</a>
        </span>
        `;
    })();
})